import * as React from "react"
import * as _ from "lodash"
import { connect } from "react-redux"
import { bindActionCreators, Dispatch } from "redux"
import { RouteComponentProps } from "react-router"
import { ReducerState, MappedActionsProps } from "../../../../../../reducer"
import * as actionCreators from "../../../../../../action-creators"
import { CardModalNotOkButton } from "../../../../../modal"
import * as Model from "../../../../../../model"
import AccountModalPresenter, { Names } from "./edit-account-modal-presenter"
import { deleteLaca } from "../../../../../../service/sfp/lacas-service"
import { NotificationProps } from "../../../../../notification"

//TODO: Faire un tri sur le tableau HandsonTable qui permettra de mettre à jour le sort du tableau lors d'une modification d'un compte

class AccountModal extends React.Component<InjectedProps, State> {
    constructor(props) {
        super(props)
        this.state = {
            applyToLocalAuthorities: [],
            chapter: null,
            loadingDelete: false,
            newAccount: this.copyAccount(props.account)
        }
    }

    componentWillReceiveProps(props: InjectedProps) {
        const newAccount: Model.Account = this.copyAccount(props.laca.account)
        this.setState({ newAccount, chapter: this.props.laca.chapter })
    }

    componentDidMount() {
        this.setState({ newAccount: this.props.laca.account, chapter: this.props.laca.chapter })
    }

    render() {
        return <AccountModalPresenter
            account={this.state.newAccount}
            chapters={this.props.chapters}
            chapter={this.state.chapter}
            classes={this.props.classes}
            instruction={this.props.instruction}
            laca={this.props.laca}
            loading={this.props.loading}
            loadingChapters={this.props.loadingChapters}
            loadingDelete={this.state.loadingDelete}
            loadingUpdate={this.props.loadingUpdate}
            notification={this.props.notification}
            onChange={e => this.handleChange(e)}
            onClickNotificationCloseButton={e => this.props.onClickNotificationCloseButton(e)}
            onClickCloseButton={this.props.onClickCloseButton}
            onClickDeleteButton={(button, e) => this.handleClickDeleteButton(button, e, this.props.laca)}
            onClickFooterButton={(button, e) => this.handleClickFooterButton(button, e)}
            onSubmit={(e) => this.props.onSubmit(this.props.laca, this.state.chapter, this.state.newAccount, e)} />
    }

    private copyAccount(account: Model.Account): Model.Account {
        return account
            ? _.clone(account)
            : {
                addedOn: null,
                class: this.props.classes[0],
                defaultChapter: null,
                expense: true,
                id: null,
                label: "",
                number: "",
                operation: true,
                receipts: true,
                removedOn: null,
                template: true,
            }
    }

    private handleChange(e: React.SyntheticEvent<Element>) {
        const target = e.target as HTMLElement
        const account = this.state.newAccount
        let chapter: Model.Chapter = this.state.chapter

        if (this.isHTMLInputElement(target)) {
            switch (target.name) {
                case Names.Expense:
                    account.expense = target.checked
                    break;
                case Names.Label:
                    account.label = target.value
                    break;
                case Names.Number:
                    account.number = target.value
                    break;
                case Names.Operation:
                    account.operation = "1" === target.value
                    break;
                case Names.Receipts:
                    account.receipts = target.checked
                    break;
            }
        } else if (this.isHTMLSelectElement(target)) {
            switch (target.name) {
                case Names.Chapter:
                    chapter = this.props.chapters.find(ch => ch.id === parseInt(target.value))
                    account.defaultChapter = chapter
                    break;
            }
        }
        this.setState({ newAccount: account, chapter })
    }

    private handleClickDeleteButton(button: CardModalNotOkButton.Delete, e: React.SyntheticEvent<Element>, laca: Model.LocalAuthorityChapterAccount) {
        this.setState({ loadingDelete: true })
        deleteLaca(this.props.localAuthority, laca.account).then(
            () => this._resolveDeleteLaca(laca.account, e),
            reason => this._rejectDeleteLaca(reason)
        )
    }

    private handleClickFooterButton(button: CardModalNotOkButton, e: React.SyntheticEvent<Element>): void {
        this.props.onClickCloseButton(e)
    }

    private isHTMLInputElement(element: HTMLElement): element is HTMLInputElement {
        return "INPUT" === element.tagName.toLocaleUpperCase()
    }

    private isHTMLSelectElement(element: HTMLElement): element is HTMLSelectElement {
        return "SELECT" === element.tagName.toLocaleUpperCase()
    }

    private _resolveDeleteLaca(account: Model.Account, e: React.SyntheticEvent<Element>) {
        _.remove(this.props.localAuthority.accounts, laca => laca.account.id === account.id)
        this.props.actions.updateCurrentLocalAuthority(this.props.localAuthority)
        this.props.onClickCloseButton(e)
    }

    private _rejectDeleteLaca(reason) {
    }
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
    return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
    return state
}

export type InjectedProps = MappedActionsProps &
    Props &
    ReducerState &
    RouteComponentProps<AccountModalParams>

export default connect(mapStateToProps, mapDispatchToProps)(AccountModal)

export interface Props {
    account?: Model.Account
    chapter?: Model.Chapter
    chapters: Model.Chapter[]
    classes: Model.Class[]
    instruction: Model.Instruction
    laca: Model.LocalAuthorityChapterAccount
    loading: boolean
    loadingChapters: boolean
    loadingUpdate: boolean
    localAuthority: Model.LocalAuthority
    notification: NotificationProps
    onClickNotificationCloseButton(e: React.SyntheticEvent<Element>): void
    onClickCloseButton(e: React.SyntheticEvent<Element>): void
    onClickDeleteButton?(e: React.SyntheticEvent<Element>): void
    onSubmit(laca: Model.LocalAuthorityChapterAccount, chapter: Model.Chapter, account: Model.Account, e: React.SyntheticEvent<Element>): void
}

interface State {
    applyToLocalAuthorities: Model.LocalAuthority[]
    chapter: Model.Chapter
    loadingDelete: boolean
    newAccount: Model.Account
}

interface AccountModalParams {
    id: string
}



// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/instruction-card/instruction-list/edit-account-modal/index.tsx